// @ts-nocheck

import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { ShareBetSvg } from '../../../../assets/svg/history';
import { Target } from '../../../../client';
import { __ } from '../../../../i18n/l10n';
import BetslipOptionsItemClick from '../BetslipOptionsItem/BetslipOptionsItemClick';

const StyledBetslipOptionsItemClick = styled(BetslipOptionsItemClick)`
  min-width: ${!Target.__MOBILE__ ? '380px' : 'auto'};
`;

type BetslipOptionsShareLinkItemProps = {
  className?: string;
  showNewTag?: boolean;
  onShareClick: () => void;
  isSuccessCopy?: null | boolean;
  resetSuccessCopy: () => void;
};

const BetslipOptionsShareLinkItem = ({
  className = '',
  showNewTag,
  onShareClick,
  isSuccessCopy = null,
  resetSuccessCopy,
}: BetslipOptionsShareLinkItemProps) => {
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  useEffect(() => {
    if (isSuccessCopy !== null) {
      setShowSuccessMessage(true);
      setTimeout(() => {
        setShowSuccessMessage(false);
      }, 3000);

      setTimeout(() => {
        resetSuccessCopy();
      }, 4000);
    }
  }, [isSuccessCopy, resetSuccessCopy]);

  return (
    <StyledBetslipOptionsItemClick
      className={className}
      label={__("Share bet to a friend's basket")}
      labelOnClick={isSuccessCopy ? __('Link copied!') : __('Internal error')}
      labelOnClickIsSuccess={!!isSuccessCopy}
      showLabelOnClick={showSuccessMessage}
      icon={<ShareBetSvg />}
      onClick={onShareClick}
      showNewTag={showNewTag}
    />
  );
};

export default BetslipOptionsShareLinkItem;
